import { Component, ElementRef, Inject, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

import { CDSMask } from '@app/utils/cds-mask';
import { ToastrService } from 'ngx-toastr';

import { IdDescricao } from '@app/models/util/id-descricao';
import { Filtros } from './filtros';
import debounce from '@app/utils/debounce';

import { ConsultasService } from '@app/services/consultas.service';
import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';



@Component({
  selector: 'app-relcustosprocesso',
  templateUrl: 'custos-processo.component.html',
  styleUrls: ['./custos-processo.component.scss']
})
export class RelatorioCustosProcessoComponent implements OnInit {

  constructor(
    private relatorioService: RelatorioService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService,
  ) {

  }

  filtros: Filtros = new Filtros();

  lstUnidades: IdDescricao[];
  lstParticipante: Array<any> = [{}];

  cdsMask: CDSMask = new CDSMask();
  totalCredito = 0;
  totalDebito = 0;
  totalSaldo = 0;


  lstProcessos: any[] = [];

  rel: any[] = [];
  relClientePagar: any[] = [];
  relClienteReceber: any[] = [];
  relAdvogado: any[] = [];
  relDespesas: any[] = [];
  relSubstabelecido: any[] = [];

  selecioneParticipante = '';
  pesquisando: boolean;

  dataRelatorio: Date;
  
  nomeParticipanteRelatorio: string = "";

  _debounce: any;
  _pesquisa: any;

  @ViewChild('relatorio') relatorio: ElementRef;

  ngOnInit() {
    this.selecioneParticipante = '-- Selecione o participante primeiro --';
    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidades = data);
  }

  pesquisar() {
    this.dataRelatorio = new Date();
    if (this.filtros.ProcessoId === undefined || this.filtros.ProcessoId === 0) {
      this.toastr.error('Processo não encontrado', 'Notificação!');
      return;
    }
    if (this.filtros.ParticipanteId <= 0) {
      this.selecioneParticipante = '-- Selecione o participante primeiro --';
      return;
    }

    this.pesquisando = true;
    this.relatorioService.custosProcesso(this.filtros.ProcessoId)
      .toPromise().then((data) => {
        this.rel = data;
        if (this.rel.length > 0) {
          this.relAdvogado = this.rel.filter(x => x.Sobre === 'Advogado');
          this.relSubstabelecido = this.rel.filter(x => x.Sobre === 'Substabelecido');
          this.relDespesas = this.rel.filter(x => x.Sobre === 'Despesas');
          this.relClienteReceber = this.rel.filter(x => x.Sobre === 'Processo');
          this.relClientePagar = this.rel.filter(x => x.Sobre === 'Cliente');

          this.somaSaldo();
        } else {
          this.toastr.info('Busca não encontrou resultados');
        }

        this.pesquisando = false;
      }, erro => {
        this.pesquisando = false;
        this.toastr.warning('Realize a pesquisa novamente.');
      });
    //  () => this.pesquisando = false);
  }

  obterProcessos(participanteId) {
    this.relatorioService.custosProcessoProcessos(participanteId).toPromise().then(
      (data) => {
        this.lstProcessos = data;
        if (data != null && data.length > 0) {
          this.selecioneParticipante = '-- Selecione o processo --';
        } else {
          this.selecioneParticipante = '-- Nenhum processo encontrado --';
        }
      });
  }

  public somaSaldo(): void {
    this.totalCredito = 0;
    this.totalDebito = 0;
    this.relClienteReceber.forEach(x => this.totalCredito += x.Valor);
    this.relAdvogado.forEach(x => this.totalDebito += x.Valor);
    this.relSubstabelecido.forEach(x => this.totalDebito += x.Valor);
    this.relDespesas.forEach(x => this.totalDebito += x.Valor);
    this.relClientePagar.forEach(x => this.totalDebito += x.Valor);
    this.totalSaldo = this.totalCredito - this.totalDebito;
  }

  public ngxselect_select(value: any) {
    this.obterProcessos(value);
  }

  public ngxselect_remove(value: any) {
    this.lstProcessos = [];
    this.selecioneParticipante = '-- Nenhum processo encontrado --';
    this.rel = [];
    this.relAdvogado = [];
    this.relSubstabelecido = [];
    this.relDespesas = [];
    this.relClienteReceber = [];
    this.relClientePagar = [];
    this.somaSaldo();
  }
  public imprimir() {
    let conteudo = document.getElementById("custosDoProcesso").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, 'Relatório custo de processo', this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());
    adicionaMapValido('Cod. Processo', this.filtros.ProcessoId);
    
    adicionaMapValido('Participante', this.nomeParticipanteRelatorio);
    
    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }
}

